import {mount} from 'svelte';

import InitializeLayout from '@js/layout';

import {onPageReady} from '@js/modules/utils';
import {videoLazyLoader} from '@js/modules/videoLazyLoader';

const RideComments = () => import('@js/components/ride/comments/RideComments.svelte');

InitializeLayout();

if (document.querySelector('.blog-article-body video.lazy-load')) {
    onPageReady(videoLazyLoader);
}

const $articleData = document.getElementById('blog-article-data');
const $comments = document.getElementById('blog-comment-component');

if ($articleData && $comments) {
    const article = JSON.parse($articleData.innerText)?.article;

    if (article?.allowComment !== false) {
        onPageReady(() => {
            RideComments()
                .then(({default: RideCommentsComponent}) => {
                    mount(RideCommentsComponent, {
                        target: $comments,
                        props: {
                            commentableType: 'blog/articles',
                            commentableId: article.id,
                            ownerId: article.adminId,
                            allowComment: article.allowComment !== false,
                            showRating: false,
                            contained: true
                        }
                    });
                });
        });
    }
}
